//Vendor
import gsap from 'gsap'
import { Flip } from "gsap/Flip"
gsap.registerPlugin(Flip)
import axios from 'axios'
import Mapbox from 'Scripts/components/Mapbox'
//Custom
import Video from 'Scripts/components/Video'
import Page from 'Scripts/classes/Page'
import { Gradient } from 'Scripts/components/Gradient'
import { getFeaturedImg } from 'Scripts/utils/wordpress'
import YTPlayer from 'yt-player'

//Class
export default class Home extends Page {
  constructor() {
    super(
      'home',
      {
        container: '.home',
        elements: {
          heroData: '.hero__cover_data h1',
          aboutTitle: '.about__title',
          aboutText: '.about__data',
          advantage: '.advantages__data',
          ccm: '.ccm__data .ccm__list',
          pdv: '.pdv',
          map: '#map',
          faqs: '#faqs .faqs__data',
          faqsItems: '.faqs__item',
          contact: '#contact',
          memberSection: '[data-member = "true"]',
          nonMemberSection: '[data-member = "false"]',
          // profilTrigger: '#profilTrigger',
          profilPage: '.profil__wrapper',
          video: '#video',
          ccmVideo: '.ccm__video'
        }
      })

    //Methods
    this.init()

  }

  init() {
    //catch selected service
    window.addEventListener('getService', this.getService.bind(this))
    // this.elements.profilTrigger.addEventListener('click', this.getProfilPage.bind(this))
  }

  async getService(e) {    
    this.serviceId = e.detail.id
    // console.log(`${process.env.API}/services/${this.serviceId}/?_fields=id,title,content,profils,acf`)
    axios.get(`${process.env.API}/services/${this.serviceId}/?_fields=id,title,content,profils,acf`)
      .then((response) => {
        this.service = response.data
        this.updatePage()
      })
      .catch((error) => {
        this.service = {}
      })
  }

  updatePage() {
    // console.log(this.service)
    //Member
    if (this.service.acf.client) {
      gsap.set(this.elements.memberSection, { display: 'block' })
      gsap.set(this.elements.nonMemberSection, { display: 'none' })
    } else {
      gsap.set(this.elements.memberSection, { display: 'none' })
      gsap.set(this.elements.nonMemberSection, { display: 'block' })
    }

    //Video
    this.initVideo()

    //Gradient
    this.initGradient()

    //Hero
    this.elements.heroData.innerHTML = this.service.acf.accroche.replace('\r\n', '<br>')

    //Presentation
    this.elements.aboutTitle.innerHTML = this.service.title.rendered
    this.elements.aboutText.innerHTML = this.service.content.rendered

    //advantages
    this.elements.advantage.innerHTML = ''
    this.service.acf.avantages.forEach(async (avantage) => {

      let icone = await getFeaturedImg(avantage.icone)
      // <svg width="50" class="advantage__icon" viewBox="0 0 22 28"><path d="M22 19.375c0 0.562-0.25 1.656-0.484 2.172-0.328 0.766-1.203 1.266-1.906 1.656-0.922 0.5-1.859 0.797-2.906 0.797-1.453 0-2.766-0.594-4.094-1.078-0.953-0.344-1.875-0.766-2.734-1.297-2.656-1.641-5.859-4.844-7.5-7.5-0.531-0.859-0.953-1.781-1.297-2.734-0.484-1.328-1.078-2.641-1.078-4.094 0-1.047 0.297-1.984 0.797-2.906 0.391-0.703 0.891-1.578 1.656-1.906 0.516-0.234 1.609-0.484 2.172-0.484 0.109 0 0.219 0 0.328 0.047 0.328 0.109 0.672 0.875 0.828 1.188 0.5 0.891 0.984 1.797 1.5 2.672 0.25 0.406 0.719 0.906 0.719 1.391 0 0.953-2.828 2.344-2.828 3.187 0 0.422 0.391 0.969 0.609 1.344 1.578 2.844 3.547 4.813 6.391 6.391 0.375 0.219 0.922 0.609 1.344 0.609 0.844 0 2.234-2.828 3.187-2.828 0.484 0 0.984 0.469 1.391 0.719 0.875 0.516 1.781 1 2.672 1.5 0.313 0.156 1.078 0.5 1.188 0.828 0.047 0.109 0.047 0.219 0.047 0.328z"></path></svg>
      this.elements.advantage.innerHTML += `<li>
                                                <img src="${icone}" class="advantage__icon"/>
                                                <sapn class='advantage__title'>${avantage.titre}</sapn>
                                                <sapn>${avantage.descriptif}</sapn>
                                            </li>`
    })

    //CCM
    this.elements.ccm.innerHTML = ''
    this.service.acf.ccm.forEach(ccm => {
      this.elements.ccm.innerHTML += `<div class='ccm__list_item'>
                                        <span>${ccm.etape}</span>
                                        <span>${ccm.descriptif}</span>
                                      </div>`
    })

    //Map
    if (this.service.acf.nos_agences) {
      this.elements.pdv.forEach(elm => elm.classList.remove('is__hidden'))
      this.initMapbox()
    } else {
      this.elements.pdv.forEach(elm => elm.classList.add('is__hidden'))
    }

    //Video
    // if (this.service.acf.ccm_video) {
    //   this.elements.video.src = this.service.acf.ccm_video
    //   this.elements.ccmVideo.classList.add('active')
    //   // this.videoToThum()
    // } else {
    //   this.elements.ccmVideo.classList.remove('active')
    // }


    if (this.service.acf.ccm_video) {      
      this.player = new YTPlayer('#video',{
        controls : false,
        keyboard : false,
        annotations : false,
        modestBranding : true,
        related : false,

      })
      this.player.load(this.service.acf.ccm_video)
      this.elements.video.classList.add('is__active')
      // this.elements.ccmVideo.innerHTML = `<iframe id="video" width="560" height="315" src="${this.service.acf.ccm_video}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>`
      // this.videoToThum()
    }else{
      this.elements.video.classList.remove('is__active')
    }

    //Faqs
    this.elements.faqs.innerHTML = ''
    this.service.acf.faqs.forEach(faq => {
      this.elements.faqs.innerHTML += `<div div class="faqs__item" ><div class="faqs__question"> <h6>${faq.question}</h6></div><div class="faqs__response">${faq.reponse}</div></div > `
    })
    // this.initFaqs()

    //activate animation
    window.dispatchEvent(new CustomEvent('pageUpdated'))

  }

  //Map functions
  async initMapbox() {
    // https://www.madmounapp.ma/wp-json/madmoun/v1/pdv/activite/1380
    // await axios.get(`${ process.env.MAP_API }/pdv/agent`)
    if (!this.elements.map) return
    if (this.mapBox) return
    await axios.get(`${process.env.MAP_API}/pdv/activite/1380`) // agences agéées
      .then((response) => {
        // console.log(response)
        this.mapBox = new Mapbox({
          selector: 'map',
          zoom: 6,
          center: [-7.6570322, 33.5722678],
          data: response.data
        })

      }).catch((error) => {
        console.log(error)
      })
  }


  initVideo() {
    new Video({ selector: 'video' })
  }


  videoToThum() {
    this.observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log('to initial place')
        } else {
          console.log('to corner')
        }
      })
    })
    this.observer.observe(this.elements.video)
  }


  initFaqs() {

    document.querySelectorAll('.faqs__item').forEach(item => {
      item.addEventListener('click', () => {
        let question = item.querySelector('.faqs__question')
        let response = item.querySelector('.faqs__response')

        //
        item.classList.toggle('is__active')
        //
        if (item.classList.contains("is__active")) {
          gsap.to(response, {
            height: 'auto',
            marginTop: 25,
            duration: 0.5,
            ease: "bounce"
          });
        } else {
          gsap.to(response, {
            height: 0,
            marginTop: 0,
            duration: 0.5,
            ease: "bounce"
          });
        }



      })
    })
  }

  initGradient() {
    // console.log(this.gradient)
    if (!this.gradient) {
      // Create your instance
      this.gradient = new Gradient()
      // Call `initGradient` with the selector to your canvas
      this.gradient.initGradient('#gradient-canvas')
    }
  }

  /**
  * Animations.
  */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

}


